import styled from 'styled-components';

export const BaseButton = styled.button`
  min-width: 165px;
  width: auto;
  height: 50px;
  letter-spacing: 0.1px;
  line-height: 50px;
  padding: 0 5px 0 5px;
  font-size: 10px;
  background-color: black;
  color: white;
  text-transform: uppercase;
  font-weight: bold;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;

  &:hover {
    background-color: white;
    color: black;
    border: 1px solid black;
  }
`;

export const SignInButton = styled(BaseButton)`
  background-color: #4285f4;
  color: white;

  &:hover {
    background-color: #357ae8;
    border: none;
  }
`;

export const InvertedButton = styled(BaseButton)`
  background-color: white;
  color: black;
  border: 1px solid black;

  &:hover {
    background-color: black;
    color: white;
    border: none;
  }
`;

export const NavigationButton = styled(BaseButton)`
  background-color: white;
  color: black;
  border: 1px solid black;
  width: 200px;

  &:hover {
    background-color: black;
    color: white;
    border: none;
  }
`;

export const SelectedNavButton = styled(BaseButton)`
  background-color: gray;
  color: black;
  border: 1px solid black;
  width: 200px;

  &:hover {
    background-color: black;
    color: white;
    border: none;
  }
`;

export const FunctionButton = styled(BaseButton)`
  background-color: gold;
  color: black;
  border: 1px solid black;

  &:hover {
    background-color: orange;
    color: white;
    border: none;
  }
`;

export const TriggerButton = styled(BaseButton)`
  background-color: white;
  color: #e11f8f;
  border: 1px solid black;

  &:hover {
    background-color: #e11f8f;
    color: white;
    border: none;
  }
`;